<template>
	<div>
		<aside class="search-btn">
			<!--  仓储账单明细 -->
            <div >
                <RadioGroup v-model="formData.chosetype" class="margin-top-10 margin-bottom-10">
                    <Radio label="0" >仓库作业费</Radio>
                    <Radio label="1" >仓储费</Radio>
                    <Radio label="2" >增值服务费</Radio> 
                    <Radio label="3" >调账</Radio> 
                </RadioGroup>
                <compCostall v-if="formData.chosetype == 0"></compCostall>
                <compStorage v-if="formData.chosetype == 1"></compStorage>
                <compZengzhi v-if="formData.chosetype == 2"></compZengzhi>
                <compReconciliation v-if="formData.chosetype == 3"></compReconciliation>
            </div>
		</aside>
	</div>
</template>
<script>
import compCostall from "./account.js";
import compStorage from "./storage.js"
import compZengzhi from "./zengzhi.js"
import compReconciliation from "./reconciliation.js"

export default {
	components: {
		compCostall,
        compStorage,
        compZengzhi,
        compReconciliation
	},
	data() {
		return {
			formData: {
                chosetype:'0',
			}
		}
	},
}
</script>
